declare var tinymce: any;

import {
  Component,
  OnDestroy,
  AfterViewInit,
  EventEmitter,
  Input,
  Output,
  NgZone,
  forwardRef
} from '@angular/core';

import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';


import "../../../node_modules/tinymce/tinymce.js";
import "../../../node_modules/tinymce/themes/modern/theme.js";
import "../../../node_modules/tinymce/plugins/code/plugin.js";
import "../../../node_modules/tinymce/plugins/link/plugin.js";
import "../../../node_modules/tinymce/plugins/paste/plugin.js";
//import "../../../node_modules/tinymce/plugins/table/plugin.js";
import "../../../node_modules/tinymce/plugins/media/plugin.js";
import "../../../node_modules/tinymce/plugins/print/plugin.js";
import "../../../node_modules/tinymce/plugins/preview/plugin.js";
import "../../../node_modules/tinymce/plugins/searchreplace/plugin.js";
import "../../../node_modules/tinymce/plugins/autolink/plugin.js";
import "../../../node_modules/tinymce/plugins/visualchars/plugin.js";
//import "../../../node_modules/tinymce/plugins/image/plugin.js";
import "../../../node_modules/tinymce/plugins/directionality/plugin.js";
import "../../../node_modules/tinymce/plugins/charmap/plugin.js";
import "../../../node_modules/tinymce/plugins/pagebreak/plugin.js";
import "../../../node_modules/tinymce/plugins/nonbreaking/plugin.js";
import "../../../node_modules/tinymce/plugins/anchor/plugin.js";
import "../../../node_modules/tinymce/plugins/hr/plugin.js";
import "../../../node_modules/tinymce/plugins/advlist/plugin.js";
import "../../../node_modules/tinymce/plugins/lists/plugin.js";
import "../../../node_modules/tinymce/plugins/textcolor/plugin.js";
import "../../../node_modules/tinymce/plugins/wordcount/plugin.js";
import "../../../node_modules/tinymce/plugins/insertdatetime/plugin.js";
import "../../../node_modules/tinymce/plugins/toc/plugin.js";
//import "../../../node_modules/tinymce/plugins/imagetools/plugin.js";
import "../../../node_modules/tinymce/plugins/contextmenu/plugin.js";
import "../../../node_modules/tinymce/plugins/colorpicker/plugin.js";
import "../../../node_modules/tinymce/plugins/visualblocks/plugin.js";
import "../../../node_modules/tinymce/plugins/fullscreen/plugin.js";
import "../../../node_modules/tinymce/plugins/textpattern/plugin.js";

@Component({
  selector: 'tinymce-editor',
  template: `<div id="{{elementId}}"></div>`,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TinyMceComponent), multi: true }
  ],
})
export class TinyMceComponent implements AfterViewInit, OnDestroy, ControlValueAccessor {
  @Input() elementId: String;
  @Output() onEditorKeyup = new EventEmitter<any>();

  editor;
  private lang: String;

  constructor(private zone: NgZone) {
    this.elementId = 'tiny-' + Math.random().toString(36).substring(2);
    this.lang = "ro";
  }


  @Input() set language(v: String) {
    if (v !== this.lang) {
      switch (v) {
        case "fr":
          this.lang = "fr_FR";
          break;
        case "en":
          this.lang = "en_GB";
          break;
        default:
          this.lang = "ro";
          break;
        case "de":
          this.lang = "de";
          break;
      }

      if (this.editor) {
        tinymce.remove(this.editor);
        this.initializeEditor();
      }
    }
  };

  initializeEditor() {
    tinymce.init({
      selector: '#' + this.elementId,
      language: `${this.lang}`,
      language_url: `assets/langs/${this.lang}.js`,
      plugins: ['code searchreplace autolink directionality visualblocks visualchars fullscreen link media charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern paste'],
      toolbar: ['formatselect | bold italic strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent | fontselect | fontsizeselect | removeformat'],
      images_upload_url: '/admin/texteditor/uploadFile',
      paste_data_images: false,
      paste_as_text: true,
      branding: false,
      image_dimensions: false,
      image_class_list: [
        { title: 'Responsive', value: 'img-responsive' }
      ],
      paste_retain_style_properties: 'all',
      min_height: 500,
      // menubar: 'edit insert view format table',
      menubar: 'edit format',
      fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
      font_formats: 'Verdana=verdana, geneva, sans-serif;Arial=arial, helvetica, sans-serif;Helvetica=helvetica, sans-serif;Courier New=courier new, courier, monospace;Monospace=monospace;Sans-Serif=sans-serif;Times New Roman=times new roman, times, serif;Times=times, serif;',
      skin_url: '/assets/skins/lightgray',
      setup: editor => {
        this.editor = editor;
        editor.on('change keyup', () => {
          if (editor) {
            const content = editor.getContent();
            this.value = content;
          }
        });
      },
      init_instance_callback: (editor) => {
        this.editor && this.editor.initialized && this.editor.setContent(this.value);
      }
    });


  }


  ngAfterViewInit() {
    this.initializeEditor();
  }

  ngOnDestroy() {
    tinymce.remove(this.editor);
  }

  private innerValue: any = '';

  private onTouchedCallback = () => { };
  private onChangeCallback = (_: any) => { };


  get value(): any {
    return this.innerValue;
  };

  @Input() set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.zone.run(() => {
        this.onChangeCallback(v);
      });
    }
  }

  onBlur() {
    this.onTouchedCallback();
  }

  writeValue(value: any) {
    if (value && value !== this.innerValue) {
      this.innerValue = value;
      if (!value) {
        value = '';
      }

      this.editor && this.editor.initialized && this.editor.setContent(value);
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }
}